<template>
  <div class="user">
    <vue-drawer-layout ref="drawerLayout" :enable="false" @mask-click="handleToggleDrawerOff">
      <div class="drawer-content" slot="drawer">
        <!-- drawer-content -->
        <nav id="menu">
          <div class="slide-container">
            <div class="profile">
              <img :src="userProfile ? userProfile : '/static/img/user@2x.png'" class="avatar" />
              <span class="badge rose">학생</span>
              <h2>{{userName}}</h2>
            </div>
            <el-menu :default-active="defaultActive" class="el-menu-vertical-demo" @select="handleSelect">
              <el-menu-item index="MAIN_S">
                <span slot="title">홈</span>
              </el-menu-item>
              <el-menu-item index="S010401">
                <span slot="title">시험 응시</span>
              </el-menu-item>
              <el-menu-item index="S010101">
                <span slot="title">시험 보기</span>
              </el-menu-item>
              <el-menu-item index="S010201">
                <span slot="title">시험 성적</span>
              </el-menu-item>
              <el-menu-item index="S010202">
                <span slot="title">종합성적표</span>
              </el-menu-item>
              <el-menu-item index="S010301">
                <span slot="title">공지사항</span>
              </el-menu-item>
              <el-menu-item index="S990101">
                <span slot="title">마이페이지</span>
              </el-menu-item>
              <el-menu-item index="S990102">
                <span slot="title">회원탈퇴</span>
              </el-menu-item>
              <el-menu-item index="LOGOUT">
                <span slot="title">로그아웃</span>
              </el-menu-item>
            </el-menu>
          </div>
        </nav>
      </div>
      <div slot="content">
        <!-- main-content -->
        <main id="panel">
          <header>
            <div class="header">
              <a href="#" class="user-menu" @click.prevent="handleToggleDrawerOn"><img src="/static/img/menu.png" srcset="/static/img/menu@2x.png" /></a>
              <a href="#" class="user-logo" @click.prevent="goMain"><img src="/static/img/logo_notext.png" /></a>
              <!-- <a href="#" class="user-profile" @click.prevent="logout"><img src="/static/img/profile-admin_2.png" /></a> -->
            </div>
          </header>
          <router-view class="container"></router-view>
        </main>
      </div>
    </vue-drawer-layout>
    <!-- <slideout ref="slideout" menu="#menu" panel="#panel" :toggleSelectors="['.user-menu']" @on-open="slideOpen" @on-close="slideClose"> -->
    <!-- </slideout> -->
  </div>
</template>

<script>

// import slideout from 'vue-slideout'

export default {
  name: 'MAIN_S',
  // components: {slideout},
  data () {
    return {
      defaultActive: '',
      userName: '',
      userProfile: ''
    }
  },
  created () {
    this.userName = this.$store.getters.user_name
    this.userProfile = this.$store.getters.user_profile
    this.defaultActive = this.$route.meta.page !== '' ? this.$route.meta.page : ''
  },
  mounted () {
    this.handleDraweLayoutStyle(false)
  },
  methods: {
    slideOpen () {
      console.log('slideoutOpen')
    },
    slideClose () {
      console.log('slideClose')
    },
    logout () {
      this.$confirm('로그아웃 하시겠습니까?', '', {
      }).then(() => {
        const userType = this.$store.getters.user_type
        this.$store.dispatch('AUTH_LOGOUT').then(() => {
          this.$router.push({name: 'LOGIN_' + userType})
        })
      }).catch(() => {})
    },
    handleToggleDrawerOn () {
      // this.$refs.drawerLayout.$el.style.overflow = 'hidden'
      this.handleDraweLayoutStyle(true)
      this.$refs.drawerLayout.toggle(true)
    },
    handleToggleDrawerOff () {
      // this.$refs.drawerLayout.$el.style.overflow = ''
      this.handleDraweLayoutStyle(false)
      this.$refs.drawerLayout.toggle(false)
    },
    goMain () {
      this.$router.push({name: 'MAIN_S'})
      this.defaultActive = 'MAIN_S'
    },
    handleSelect (key, keyPath) {
      if (key === 'LOGOUT') {
        this.logout()
      } else {
        this.$router.push({name: key})
      }
      this.handleToggleDrawerOff()
      // this.$refs.slideout.slideout.close()
    },
    handleDraweLayoutStyle (isHidden) {
      this.$refs.drawerLayout.$el.style.overflow = isHidden ? 'hidden' : 'auto'
      const layouts = this.$refs.drawerLayout.$el.children
      if (layouts && layouts.length > 1) {
        layouts[1].style.overflow = isHidden ? 'hidden' : 'auto'
      }
    },
    updateUserProfile () {
      this.userName = this.$store.getters.user_name
      this.userProfile = this.$store.getters.user_profile
    }
  }
}
</script>

<style scoped>
  body {
    width: 100%;
    height: 100%;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/User.vue